import AlertBarLoader from './AlertBarLoader'

export default AlertBarLoader
// eslint-disable-next-line import/export
export * from './AlertBarLoader'
